import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-pre-netflix-modal',
  templateUrl: './pre-netflix-modal.component.html',
  styleUrls: ['./pre-netflix-modal.component.scss'],
})
export class PreNetflixModalComponent {
  checked = false;
  constructor(private dialogRef: MatDialogRef<PreNetflixModalComponent>) {}

  onOk() {
    this.dialogRef.close(true);
  }
}
